<div style="overflow: scroll; max-height: calc(100svh - 350px);">
  <div class="p-fluid p-grid"
    style="padding-right: 15px">
    <div class="p-field p-lg-5">
      <habil-label name="txtNome"
        label="Cliente">
        <input type="text"
          name="txtNome"
          pInputText
          [(ngModel)]="registro.nome" />
      </habil-label>
    </div>
    <div class="p-field p-lg-3">
      <habil-label name="txtCnpj"
        label="CPF / CNPJ">
        <input type="text"
          name="txtCnpj"
          pInputText
          [(ngModel)]="registro.cnpj" />
      </habil-label>
    </div>

    <div class="p-col-12 p-field"
      *ngIf="liberacao?.produtos">
      <habil-label name="lbresumo"
        label="Resumo do Pedido">
        <p-table [value]="liberacao.produtos">
          <ng-template pTemplate="header">
            <tr>
              <th>Descrição</th>
              <th>Qtde</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body"
            let-p>
            <tr>
              <td>{{ p.descricao }}</td>
              <td>{{ p.qtde }}</td>
            </tr>
          </ng-template>
        </p-table>
      </habil-label>
    </div>
    <div class="p-col-12 p-field"
      *ngIf="liberacao?.observacoes">
      <habil-label name="lbobs"
        label="Observações">
        <textarea pInputTextarea
          [(ngModel)]="liberacao.observacoes"
          [rows]="10"></textarea>
      </habil-label>
    </div>
    <!-- <div class="p-field p-lg-2">
        <habil-label name="ddSoftwares" label="Software">
          <p-dropdown
            name="ddSoftwares"
            optionValue="value"
            optionLabel="label"
            [disabled]="true"
            [(ngModel)]="licenca.software"
            [options]="softwares"
          >
          </p-dropdown>
        </habil-label>
      </div> -->
    <!-- <div class="p-field p-lg-2 p-col-align-center">
        <br />
        <p-checkbox
          [binary]="true"
          [(ngModel)]="obj.acessoGeral"
          label="Acesso geral"
        ></p-checkbox>
      </div> -->
    <!-- <div class="p-field p-lg-3">
        <habil-label name="txtIp" label="IP">
          <input type="text" name="txtIp" pInputText [(ngModel)]="obj.mod" />
        </habil-label>
      </div> -->
    <div class="p-field p-lg-2">
      <habil-label name="deVctoChave"
        label="Vencimento">
        <habil-date-edit name="deVctoChave"
          [disabled]="bloqueiaAlterarVencimento()"
          [(ngModel)]="obj.val">
        </habil-date-edit>
      </habil-label>
    </div>
    <div class="p-field p-col-1"
      *ngIf="permiteAlterarTrial() && (!bloqueiaAlterarVencimento() || !oldTrial)"
      [pTooltip]="tooltipNovoVencimento()">
      <habil-label name="inTrial"
        label="Dias Trial">
        <p-inputNumber style="max-height: 36px !important;"
          inputId="inTrial"
          [(ngModel)]="obj.trial"
          [showButtons]="true"
          [disabled]="oldTrial && bloqueiaAlterarVencimento()"
          [min]="0"
          [max]="5"
          suffix=" dias">
        </p-inputNumber>
      </habil-label>
    </div>
    <div class="p-field p-lg-2">
      <habil-label name="inNroLicencas"
        label="Licenças">
        <p-inputNumber inputId="inNroLicencas"
          [(ngModel)]="obj.users">
        </p-inputNumber>
      </habil-label>
    </div>

    <div class="p-field p-col-1">
      <habil-label name="lbversao"
        label="Versão">
        <p-dropdown [options]="versao"
          [(ngModel)]="obj.versao"
          optionLabel="value"
          optionValue="value"></p-dropdown>
      </habil-label>
    </div>
    <div class="p-field p-col-1">
      <habil-label name="lbversao"
        label="Versão NFe">
        <p-dropdown [options]="versaoNFe"
          [(ngModel)]="obj.vNfe"
          optionLabel="value"
          optionValue="value"></p-dropdown>
      </habil-label>
    </div>
    <div class="p-field p-col-3">
      <habil-label name="solucao"
        label="Solução">
        <p-dropdown [options]="todosOsModulos"
          [(ngModel)]="produto"
          (onChange)="onChangeSolucao()"
          optionLabel="nomeProduto"
          optionValue=""></p-dropdown>
      </habil-label>
    </div>
    <div class="p-col-12"></div>
    <div class="p-field p-col-fixed">
      <br />
      <p-checkbox [binary]="true"
        [(ngModel)]="obj.cf"
        label="Cupom fiscal"></p-checkbox>
    </div>
    <div class="p-field p-col-fixed">
      <br />
      <p-checkbox [binary]="true"
        [(ngModel)]="obj.contrato"
        label="Contratos"></p-checkbox>
    </div>
    <div class="p-field p-col-fixed">
      <br />
      <p-checkbox [binary]="true"
        [(ngModel)]="obj.compras"
        label="Ordem de compra"></p-checkbox>
    </div>
    <div class="p-field p-col-fixed">
      <br />
      <p-checkbox [binary]="true"
        [(ngModel)]="obj.almoxarifado"
        label="Almoxarifado"></p-checkbox>
    </div>
    <div class="p-field p-col-fixed">
      <br />
      <p-checkbox [binary]="true"
        [(ngModel)]="obj.magento"
        label="Magento"></p-checkbox>
    </div>
    <div class="p-field p-col-fixed">
      <br />
      <p-checkbox [binary]="true"
        [(ngModel)]="graficos"
        label="Gráficos"></p-checkbox>
    </div>
    <div class="p-field p-col-fixed">
      <br />
      <p-checkbox [binary]="true"
        [(ngModel)]="spedFiscal"
        label="SPED Fiscal"></p-checkbox>
    </div>
    <div class="p-field p-col-fixed">
      <br />
      <p-checkbox [binary]="true"
        [(ngModel)]="spedPisCofins"
        label="SPED PIS/COFINS"></p-checkbox>
    </div>
    <div class="p-col-12"></div>
    <div class="p-field p-col-fixed">
      <br />
      <p-checkbox [binary]="true"
        [(ngModel)]="obj.nfe"
        label="NF-e"></p-checkbox>
    </div>
    <div class="p-field p-col-fixed">
      <br />
      <p-checkbox [binary]="true"
        [(ngModel)]="obj.nfce"
        label="NFC-e"></p-checkbox>
    </div>
    <div class="p-field p-col-fixed">
      <br />
      <p-checkbox [binary]="true"
        [(ngModel)]="obj.nfse"
        label="NFS-e"></p-checkbox>
    </div>
    <div class="p-field p-col-fixed">
      <br />
      <p-checkbox [binary]="true"
        [(ngModel)]="obj.sat"
        label="SAT"></p-checkbox>
    </div>
    <div class="p-col-12"></div>
    <div class="p-field p-col-6"
      *ngIf="obj.nfe">
      <habil-label name="lbcnpjnfe"
        label="NFe - CNPJs liberados (separe usando vírgula)">
        <p-chips separator=","
          [(ngModel)]="obj.nfeCnpjs"></p-chips>
      </habil-label>
    </div>
    <div class="p-field p-col-6"
      *ngIf="obj.nfce">
      <habil-label name="lbcnpjncfe"
        label="NFCe - CNPJs liberados (separe usando vírgula)">
        <p-chips separator=","
          [(ngModel)]="obj.nfceCnpjs"></p-chips>
      </habil-label>
    </div>
    <div class="p-field p-col-6"
      *ngIf="obj.nfse">
      <habil-label name="lbcnpjnfe"
        label="NFSe - CNPJs liberados (separe usando vírgula)">
        <p-chips separator=","
          [(ngModel)]="obj.nfseCnpjs"></p-chips>
      </habil-label>
    </div>
    <div class="p-field p-col-6"
      *ngIf="obj.sat">
      <habil-label name="lbcnpjnfe"
        label="SAT - CNPJs liberados (separe usando vírgula)">
        <p-chips separator=","
          [(ngModel)]="obj.satCnpjs"></p-chips>
      </habil-label>
    </div>
  </div>
</div>
<hr />
<div class="p-grid">
  <div class="p-col-2">
    <button pButton
      type="button"
      style="width: 100%"
      class="p-button-outlined p-button-danger"
      label="Cancelar"
      icon="pi pi-times"
      (click)="cancelar()"></button>
  </div>
  <div class="p-col"></div>
  <div class="p-col-2">
    <button pButton
      type="button"
      style="width: 100%"
      class="p-button-success"
      [loading]="loading"
      label="Salvar"
      icon="pi pi-check"
      (click)="salvar()"></button>
  </div>
</div>